import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { resolveHostedUrl } from 'src/app/constants/hosted-api-urls';
import { TABLE_BOOKINGS_STATUS_ENUM } from '../enums/table-bookings.enum';
@Injectable()
export class TableBookingApiService {
  private get reservationEndPoint(): string {
    return resolveHostedUrl('reservationURL');
  }
  private get nestURL(): string {
    return resolveHostedUrl('nestURL');
  }

  constructor(private _http: HttpClient) {}

  // Fetches all table booking orders for a specific restaurant ID with optional filtering.
  getAllTableBookingOrders(
    restId: string,
    params: HttpParams
  ): Observable<any> {
    const url = `${this.reservationEndPoint}/v1/reservation/list/${restId}`;
    return this._http.get(url, { params });
  }

  cancelOrRejectTableBookings(payload) {
    const url = `${this.reservationEndPoint}/v1/reservation/request-cancellation`;
    return this._http.post(url, payload);
  }

  modifyTableBooking(payload) {
    const url = `${this.reservationEndPoint}/v1/reservation/request-modification`;
    return this._http.post(url, payload);
  }

  checkInOrAcceptTableBooking(payload) {
    const url = `${this.reservationEndPoint}/v1/reservation/modify`;
    return this._http.post(url, payload);
  }

  reservationCountForCalender(restId, params) {
    const url = `${this.reservationEndPoint}/v1/reservation/list/count/${restId}`;
    return this._http.get(url, { params });
  }

  checkAvailibility(payload) {
    const url = `${this.reservationEndPoint}/v1/reservation/check-availability`;
    return this._http.post(url, payload);
  }

  acknowledgePendingWarn() {
    const url = `${this.reservationEndPoint}reservation/api/v1/reservation/ack-pending-warn`;
    return this._http.post(url, {});
  }
  
  createOrUpdateReservationSettings(param) {
    const url = `${this.nestURL}/api/restaurant/reservation`
    return this._http.put<any>(url, param);
  }

  getHttpParamsForAllTableBookings(startEndEpochObj: any): HttpParams {
    let params = new HttpParams()
      .set('page_no', '1')
      .set('limit', '500')
      .set('response_format', '2')
      .set('status', TABLE_BOOKINGS_STATUS_ENUM.ACCEPTED)
      .set('start_epoch', startEndEpochObj.startTimeEpoch.toString())
      .set('end_epoch', startEndEpochObj.endTimeEpoch.toString());
    return params;
  }
}
